import InfiniteScroll from "react-infinite-scroll-component";

import { SimpleLoader } from "~/components/UI/SimpleLoader";
import { colors } from "~/constants/styles";
import { HeadCell } from "~/types/common/headCell.type";
import { MyPayOut } from "~/types/data/Accounting.types";

import styles from "./index.module.scss";
import PayOutsTableBody from "./PayOutsTableBody";
import PayOutsTableHead from "./PayOutsTableHead";

interface Props {
  payOuts?: MyPayOut[];
  selectedRows: MyPayOut[];
  onCheckboxChange: (product: MyPayOut) => void;
  onSelectAllChange: (selected: boolean) => void;
  isSelectedAll: boolean;
  hasMoreData: boolean;
  fetchMoreData: () => void;
}

const HEADCELLS: HeadCell<MyPayOut>[] = [
  { id: 1, label: "", isCheckbox: true },
  {
    id: 2,
    label: "Date de création",
    isSortable: true,
    associatedKey: "paidOutAt",
  },
  {
    id: 3,
    label: "Montant commission",
    isSortable: true,
    associatedKey: "reedooCommissionAmount",
  },
  {
    id: 4,
    label: "Montant payable",
    isSortable: true,
    associatedKey: "amount",
  },
  {
    id: 5,
    label: "Statut",
    isSortable: true,
    associatedKey: "payoutStatus",
  },
  {
    id: 6,
    label: "N° facture",
    isSortable: true,
    associatedKey: "id",
  },
  { id: 7, label: "" },
];

const PayOutsTable = ({
  payOuts,
  fetchMoreData,
  hasMoreData,
  selectedRows,
  isSelectedAll,
  onCheckboxChange,
  onSelectAllChange,
}: Props) => {
  return (
    <>
      <InfiniteScroll
        dataLength={payOuts?.length ?? 0}
        next={fetchMoreData}
        hasMore={!!payOuts && hasMoreData}
        loader={<h4 style={{ textAlign: "center" }}>Loading...</h4>}
      >
        <table className={`${styles.table}`}>
          <PayOutsTableHead
            headCells={HEADCELLS}
            onSelectAllChange={onSelectAllChange}
            allSelected={isSelectedAll}
          />
          <PayOutsTableBody
            payOuts={payOuts ?? []}
            onCheckboxChange={onCheckboxChange}
            selectedRows={selectedRows}
          />
        </table>
      </InfiniteScroll>
      {!payOuts && (
        <div className={styles.loaderContainer}>
          <SimpleLoader size="size3" fill={colors.$primary} />
        </div>
      )}
    </>
  );
};

export default PayOutsTable;
